import { cofaceAccessTypes } from './cofaceAccessTypes';

export const creditReviewRequestTooltips = {
  [cofaceAccessTypes.REQUEST_ALLOWED]: '',
  [cofaceAccessTypes.REQUEST_NOT_ALLOWED]:
    'You have no permission to request this item. Please contact your organisation admin',
  [cofaceAccessTypes.NO_CONTRACT_ID]:
    'You have no license to request this item. Please contact your personal advisor',
  [cofaceAccessTypes.NOT_ENOUGH_CREDITS]:
    'You have not enough credits to request this item. Please contact your personal advisor',
};
